import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const VivaEngageAppNotifications = () =>
  import(/* webpackChunkName: "4-feat-vivaengageappnotifications" */ './VivaEngageAppNotifications');
const LoadableVivaEngageAppNotifications: ComponentType = lazyLoadOnRender({ loader: VivaEngageAppNotifications });
export default LoadableVivaEngageAppNotifications;
